import { IBasicReturn } from '@interfaces/IBasicReturn';
import { IUser } from '@interfaces/IUser';
import appAxiosInstance from '@utils/appAxiosInstance';


const onSwitchUsers = async (userEmail: string): Promise<IBasicReturn<IUser>> => {
  let user: IBasicReturn<IUser> = {
    Success: true,
  };

  await appAxiosInstance()
    .get<IBasicReturn<IUser>>(`Identity/SwitchTo/${userEmail}`)
    .then((response): IBasicReturn<IUser> => {
      const { data } = response;

      user = data;

      return user;
    })
    .catch((): IBasicReturn<IUser> => {
      user.Success = false;

      return user;
    });

  return user;
};

export default onSwitchUsers;
